export const availabilityMap = {
  10: 'Actively Looking',
  20: 'Open to Work',
  30: 'Do not Contact'
};
